module.exports = __webpack_public_path__ + "img/qq.0f8e743b.png";